/** Text the voice layer is allowed to speak — never raw JSON / agent_config. */

const HARNESS_ACTIONS = new Set([
  'api_tool',
  'mcp_tool',
  'datasource_query',
  'code_exec',
  'job_request',
  'thinking',
  'mode_resolved',
]);

export function extractSpokenText(raw: string): string {
  const trimmed = (raw || '').trim();
  if (!trimmed) return '';

  if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
    try {
      const data = JSON.parse(trimmed) as Record<string, unknown>;
      if (data && typeof data === 'object') {
        const value = data.message;
        if (typeof value === 'string' && value.trim()) {
          return stripMarkdown(value);
        }
        return '';
      }
    } catch {
      return stripMarkdown(trimmed);
    }
  }

  return stripMarkdown(trimmed);
}

export function isHarnessActionPayload(raw: string): boolean {
  const trimmed = (raw || '').trim();
  if (!trimmed) return false;
  if (
    trimmed.startsWith('API tool result for ') ||
    trimmed.startsWith('Custom MCP tool result for ')
  ) {
    return true;
  }
  const jsonText = extractJsonObject(trimmed);
  if (!jsonText) return false;
  try {
    const data = JSON.parse(jsonText) as Record<string, unknown>;
    return Boolean(data && HARNESS_ACTIONS.has(String(data.action || '')));
  } catch {
    return false;
  }
}

/** User-visible playground text. Empty means wait for the spoken answer. */
export function assistantDisplayText(raw: string): string {
  const spoken = extractSpokenText(raw);
  if (spoken && !isHarnessActionPayload(raw)) return spoken;
  if (isHarnessActionPayload(raw)) return '';
  return spoken;
}

function extractJsonObject(text: string): string | null {
  const trimmed = text.trim();
  if (trimmed.startsWith('{') && trimmed.endsWith('}')) return trimmed;
  const fenced = trimmed.match(/```(?:json)?\s*(\{[\s\S]*?\})\s*```/);
  return fenced ? fenced[1] : null;
}

function stripMarkdown(text: string): string {
  let out = text;
  out = out.replace(/```[\s\S]*?```/g, '');
  out = out.replace(/`[^`]+`/g, '');
  out = out.replace(/https?:\/\/\S+/g, '');
  out = out.replace(/^#{1,6}\s+/gm, '');
  out = out.replace(/\*\*([^*]+)\*\*/g, '$1');
  out = out.replace(/\*([^*]+)\*/g, '$1');
  out = out.replace(/\s+/g, ' ');
  return out.trim();
}
